export default __webpack_public_path__ + "static/media/image2.90120c85.jpg";